<!--
Copyright (C) Cocouz Oy 2017 - All Rights Reserved
-->
<template>
  <div class="col-lg-5 col-xl-4">

            <div class="aside position-none" id="aside" v-bind:style="stickyObject" :class="{'stop-float': footerCollided}">
            <MPCollider v-collision="['groupone']" @collide="onCollideHandler" @non-collide="nonCollideHandler" @collide-groupone="onGroupOneCollide" @non-collide-groupone="nonGroupOneCollide" />
              <!-- Price -->

              <div class="price" v-if="!showEnquiry && !isDisabled">

                <h3 class="price__value" v-if="currentTab == 'room'"><pulse-loader :color="'grey'" id="loadingThing" v-if="isLoading"></pulse-loader><span v-if="!isLoading">{{ currencySymbol }} {{ selectedPrice }}</span><span v-if="!isLoading" class="price__decimals">{{selectedPrice_decimal}}</span></h3>
                <h3 class="price__value" v-else><pulse-loader :color="'grey'" id="loadingThing" v-if="isLoading"></pulse-loader><span v-if="!isLoading">{{ currencySymbol }} {{ p_selectedPrice }}</span><span v-if="!isLoading" class="price__decimals"> {{p_selectedPrice_decimal}}</span></h3>
                <p class="price__definition" > {{ strings.perPerson}}</p>

                <div class="ribbon ribbon--with-icon price__ribbon" v-if="isInstantBookable">
                  <img src="../assets/img/icon-flash.svg" alt="" class="ribbon__img">
                  {{ strings.availableImmediately}}
                </div>
              </div>
              <div class="price" v-else></div>

              <!-- Form -->
              <form action="" class="form aside__basics">
                <div class="input-group">
                  <label class="form__label  input-group__item input-group__item--longer">
                    {{ strings.startdate }}
                    <input v-model="s_date" class="flatpickr form__input js-datepicker flatpickr-input" id="fpick" ref="fpick" :placeholder="strings.whenyourmeetingis">
                  </label>

                  <!--<label class="form__label  input-group__item">
                    {{ strings.starttime }}
                    <input v-model="s_time" class="flatpickr form__input js-datepicker flatpickr-input" id="fpick_time" ref="fpick_time" :placeholder="strings.whenyourmeetingis">
                  </label>-->
                  <!--<label class="form__label  input-group__item">
                    {{ strings.starttime }}
                    <vue-timepicker class="vueTimePicker" :minute-interval="15" hide-clear-button></vue-timepicker>
                  </label>-->
                  <vue-timepicker v-model="s_time" class="vueTimePicker" :minute-interval="15" :hour-range="getTimePickerHourRange" hide-clear-button></vue-timepicker>
                  </div>

                
                
                <div class="input-group">
                  <label class="form__label input-group__item input-group__item--longer">{{ strings.length }}
                    <select name="length" class="form__input form__select" :class="{'ie': isIE }" v-model="s_meetingLength">
                      <option value="2">2 h</option>
                      <option value="3">3 h</option>
                      <option value="4">4 h</option>
                      <option value="5">5 h</option>
                      <option value="6">6 h</option>
                      <option value="7">7 h</option>
                      <option value="8">8 h</option>
                      <option value="9">9 h</option>
                      <option value="10">10 h</option>
                      <option value="overnight">{{ strings.overnight }}</option>
                      <option value="twodays">{{ strings.twodays }}</option>
                    </select>
                  </label>
                  <label class="form__label input-group__item">{{ strings.attendees }}
                    <input type="number" class="form__input" :placeholder="strings.howmany" v-model.lazy="s_delegates" v-debounce="300">
                  </label>

                </div>

                <p class="form__note" v-if="isOutsideBusinessHours && businessHours['start_time']" style="text-align: center; font-size:14px;">{{ strings.bizHours }}: {{ businessHours['start_time'] }} - {{ businessHours['end_time'] }}</p>
                <p class="form__note" v-if="isOutsideBusinessHours && businessHours['venue_closed']" style="text-align: center; font-size:14px;">{{ strings.venueClosed }}</p>

              </form>

              <!-- Room and / or package selection -->

              <ul class="tabs tabs--aside">
                <li class="tabs__item" :class="{'current' : packageCurrent}" data-tab="tab-1" @click="changeCurrentTab('package')" v-if="!isPackageTabRemoved">{{ strings.packagetab}}</li>
                <li class="tabs__item" :class="{'current' : roomCurrent}" data-tab="tab-2" @click="changeCurrentTab('room')" v-if="!isPackageTabRemoved">{{ strings.roomtab }}</li>
              <!--  <li class="tabs__item current" v-if="showEnquiry">Enquiry</li> -->
              </ul>

              <div class="tabs__container">

                <div id="tab-1" class="tabs__content" v-if="!showEnquiry" :class="{'current' :packageCurrent}">

                  <div class="input-group input-group--mobile">
                    <label class="form__label input-group__item">{{ strings.packagetab }} <span class="js-expand-details form__details--package"  @click="togglePackageDetails()">{{ detailsPackageText }}</span>
                      <select name="package" class="form__input form__select" v-model="s_package" :disabled="isDisabled">
                        <option :value="item.id" v-for="(item, key) in packageInfo" :key="key" v-if="isRightPackage(item.package_length) && item.available == '1' && item.exceed == 'no' && item.allRoomUnavailable == 'no'">{{ !item.title[lang] ? item.title.en : item.title[lang] }}</option>
                      </select>
                    </label>

                    <label class="form__label input-group__item">{{ strings.room }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                      <select name="room" class="form__input form__select" v-model="s_room" :disabled="isDisabled">
                        <option :value="item.id" v-for="(item, key) in this.$store.state.rooms_in_package" :key="key" v-if="item.available == '1' && item.exceed == 'no'">{{ item.title }} </option>
                      </select>
                    </label>
                  </div>

                  <label class="form__label">{{ strings.seatingorder }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                    <select name="seating-order" class="form__input form__select" v-model="s_layout" :disabled="isDisabled">
                      <option :value="item.value" v-for="(item, key) in this.$store.state.layouts_in_room_in_package" :key="key" v-if="parseInt(item.max_delegate) >= delegates || item.value == '_none'">{{ item.name }}</option>
                    </select>
                  </label>

                </div>

                <div id="tab-2" class="tabs__content" v-if="!showEnquiry" :class="{'current' :roomCurrent}">

                   <label class="form__label">{{ strings.room }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                     <!-- apply this class for validation:  form--invalid -->
                     <select name="room" class="form__input form__select" v-model="s_room" :disabled="isDisabled">
                       <option :value="item.id" v-for="(item, key) in roomInfo" :key="key" v-if="item.available == '1' && item.exceed == 'no'">{{ item.title }}</option>
                     </select>
                     <!--<p class="form__note">Choose your package</p>-->
                   </label>

                   <label class="form__label">{{ strings.seatingorder }} <span class="js-expand-details form__details--room" @click="toggleDetails()">{{ detailsRoomText }}</span>
                    <select name="seating-order" class="form__input form__select" v-model="s_layout" :disabled="isDisabled">
                      <option :value="item.value" v-for="(item, key) in this.$store.state.layouts_in_room" :key="key" v-if="parseInt(item.max_delegate) >= delegates || item.value == '_none'">{{ item.name }}</option>
                    </select>
                  </label>

                </div>

                <div class="current" v-if="showEnquiry">
                  <form @submit.prevent="create()">

                    <div v-if="false">
                    <label class="form__label input-group__item">{{ strings.additional_info }}  </label>
                    <textarea
                      class="form__textarea" name="additional_info"
                      :placeholder="strings.additional_info_placeholder"
                      v-model="s_additional_info"
                    ></textarea>
                    <service-fee v-if="showServiceFee"  />
                    </div>
                    <button type="submit" href="" class="button button--success button--full tabs__button" v-if="showEnquiry" :disabled="isDisabled || isOutsideBusinessHours" :class="{'button--disabled':isDisabled || isOutsideBusinessHours}">{{ strings.enquiry }}</button>
                  </form>
                </div>

                <div class="aside__summary" v-if="!showEnquiry && !isDisabled">
                  <div class="aside__total big_flex">{{ strings.total }}<span class="aside__detail"> ({{ strings.inclVat }})</span>
                   <span class="small_text" v-if="showEstimatedLocalPrice">
                      <br>
                      {{ strings.estimatedTotal }} {{localCurrencyCode}}
                    </span>
                  </div>
                  <div class="aside__value" v-if="!isLoading"> 
                    {{ totalPrice }} {{ currencyCode }} 
                    <span class="small_text" v-if="showEstimatedLocalPrice">
                      <br>
                      {{ localTotalPrice }} {{localCurrencyCode}}
                    </span>
                  </div>
                </div>
                
                <div class="tabs__cta">
                  <button href="" class="button button--success button--full tabs__button" :class="{'button--disabled':isDisabled || isOutsideBusinessHours}" @click="create()" v-if="!showEnquiry" :disabled="isDisabled || isOutsideBusinessHours">{{ isInstantBookable ? strings.book_now : strings.continue }}</button>
                  <div style="font-size: 12px;margin-top: 1em;" id="gdpr-stuff">
                    <input id="marketing_gdpr" type="checkbox" v-model="accepted_gdpr" v-if="showEnquiry"><span style="margin-left: 5px;" v-if="showEnquiry">{{ strings.marketing_gdpr }}</span>
                  </div>        
                  <ul class="checklist checklist--spacing checklist--info">
                    <li class="checklist__item checklist__item--info" v-if="!isSJP">{{ strings.standardEnquiries }}</li>
                    <li class="checklist__item checklist__item--info hideForBE" >{{ strings.direct }}</li>
                    <div v-if="!isCWTDomain">
                      <li class="checklist__item checklist__item--info hideForBE" v-if="!isUSCase">{{ strings.call }} {{ phoneNumber }} {{ strings.ifyouneed }} </li>
                      <li class="checklist__item checklist__item--info hideForBE" v-else>For assistance, call 678-338-2100 between 9am and 5pm (ET).</li>
                    </div>
                  </ul>
                  <p class="tabs__enquiry-note" v-if="showEnquiry">{{ strings.plzsendenquiry }}</p>
                </div>
              </div>

            </div>
          </div>
</template>

<script>
  //import flatPickr from 'vue-flatpickr-component';
  import fpickr from "flatpickr"
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  //import locale for flatpickr.
  import { Russian } from "flatpickr/dist/l10n/ru.js";
  import { Finnish } from "flatpickr/dist/l10n/fi.js"
  import { Danish } from "flatpickr/dist/l10n/da.js"
  import { French } from "flatpickr/dist/l10n/fr.js"
  import { German } from "flatpickr/dist/l10n/de.js"
  import { Italian } from "flatpickr/dist/l10n/it.js"
  import { Latvian } from "flatpickr/dist/l10n/lv.js"
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { Swedish } from "flatpickr/dist/l10n/sv.js"
  import { Mandarin } from "flatpickr/dist/l10n/zh.js"
  import { Czech } from "flatpickr/dist/l10n/cs.js"
  import { english } from "flatpickr/dist/l10n/default.js"

  // import locacle for vee-validate.
  import arabic from 'vee-validate/dist/locale/ar';
  import russian from "vee-validate/dist/locale/ru";
  import finnish from "vee-validate/dist/locale/fi"
  import danish from "vee-validate/dist/locale/da"
  import french from "vee-validate/dist/locale/fr"
  import german from "vee-validate/dist/locale/de"
  import italian from "vee-validate/dist/locale/it"
  //import latvian from "vee-validate/dist/locale/lv"
  import spanish from "vee-validate/dist/locale/es"
  import swedish from "vee-validate/dist/locale/sv"
  import chinese from "vee-validate/dist/locale/zh_CN"

  import MPCollider from './Collider';
  import Vue from 'vue'
  import VueResource from 'vue-resource';
  import moment from 'moment';

  import VuePhoneInput from './VuePhoneInput'
  const { detect } = require('detect-browser');
  const browser = detect();
  import * as hf from '../assets/misc/helperFunctions.js'

  import VueTimepicker from 'vue2-timepicker'
  import ServiceFee from './ServiceFee';
  import * as dataLayer from '../assets/misc/dataLayer.js';

  Vue.use(VueResource);

  export default {
    props: ['lang'],
    components: {
      MPCollider,
      PulseLoader,
      VuePhoneInput,
      VueTimepicker,
      ServiceFee
   },
    data () {
      return {
        date: null,
        checkboxServiceFee: false,
        stickyObject:  {},
        vInfo : '',
        s_email: '',
        s_phone: '',
        s_name: '',
        pInfo: '',
        roomPrice: '',
        roomTotalPrice: '',
        packagePrice: '',
        packageTotalPrice: '',
        s_lname: '',
        s_company: '',
        s_additional_info: '',
        isIE: false,
        details: true,
        detailsPackage: true,
        errorMessages: { "email": ""},
        detailsRoomText: this.$store.state.strings.details,
        detailsPackageText: this.$store.state.strings.details,
        noCC: false,
        s_phone_logged_in: '',
        s_timee: '10:15',
        _accepted_gdpr: false
      }
    },
    created () {
      this.$validator.localize('ar', arabic);
      this.$validator.localize('ru', russian);
      this.$validator.localize('fi', finnish);
      this.$validator.localize('da', danish);
      this.$validator.localize('fr', french);
      this.$validator.localize('de', german);
      this.$validator.localize('it', italian);
      this.$validator.localize('es', spanish);
      this.$validator.localize('sv', swedish);
      //this.$validator.localize('lv', latvian);
      this.$validator.localize('zh', chinese);

      // start with english locale.
      this.$validator.localize('en');
    },
    methods: {
      translateDurationType(length){
        let duration_type = "other";
        if(length <= 5){
          duration_type = "half-day";
        }else if(length <= 12){
             duration_type = "full-day";
        }
        return duration_type;
    },
    storeProduct(product, venue){
      let isRoomType = product.order_type == 'room';
      let id_prefix = isRoomType ? 'r': 'n';
      let name_prefix = isRoomType ? 'room - ': 'package - ';

      product.total_price = isRoomType ? product.room_price_total: product.package_price_total;
      product.layout_en = this.$store.state.strings.layouts_en[product.layout];
      let payload = {
              "id": id_prefix + product.id,
              "name": name_prefix + product.title,
              "category": product.category,
              "brand": this.$store.state.venueInfo.title + ' - ' + this.$store.state.venueInfo.id,
              "price":  product.total_price,
              "quantity": isRoomType ? 1: product.delegates,
              "dimension3": this.$store.state.venueInfo.city,
              "dimension4": this.$store.state.venueInfo.country_code,
              "dimension5": this.$store.state.venueInfo.venue_type_en,
              "dimension6": product.mt_length,
              "dimension7": this.translateDurationType(product.mt_length),
              "dimension8": product.layout_en,
              "dimension9": moment(product.start,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
              "dimension10": moment(product.end,'DD-MM-YYYY HH:mm').format("DD/MM/YYYY HH:mm"),
              "dimension12": product.isInstantBookable == 1 ? 'instant booking': product.total_price ? 'booking request': "enquiry",
              "metric1": product.delegates,
              "metric2": isRoomType ? product.total_price: product.total_price / product.delegates,
            };
       localStorage.setItem('checkoutProduct', JSON.stringify(payload));
       localStorage.setItem('venueInfo', JSON.stringify(venue));
    },
      reRender(lang) {
        this.$validator.localize(lang);
        switch (lang) {
          case 'ru':
            fpickr.localize(Russian);
            break;
          case 'fi':
            fpickr.localize(Finnish);
            break;
          case 'da':
            fpickr.localize(Danish);
            break;
          case 'fr':
            fpickr.localize(French);
            break;
          case 'de':
            fpickr.localize(German);
            break;
          case 'it':
            fpickr.localize(Italian);
            break;
          case 'lv':
            fpickr.localize(Latvian);
            break;
          case 'es':
            fpickr.localize(Spanish);
            break;
          case 'sv':
            fpickr.localize(Swedish);
            break;
          case 'zh':
            fpickr.localize(Mandarin);
            break;
          case 'cs':
            fpickr.localize(Czech);
            break;
          case 'en':
            fpickr.localize(english);
            break;
          default:
            break;
        }
        let isOpera = this.$store.state.isOpera;
        let date = moment(this.$store.state.date, 'DD-MM-YYYY');
        let defaultDate = moment();

        let finalDate = '';
        if(date > defaultDate){
          finalDate = date;
        } else {
          this.$store.commit('setDate', defaultDate.format('DD-MM-YYYY'));
          finalDate = defaultDate;
        }

        if(isOpera){
            finalDate = moment(finalDate, 'DD-MM-YYYY');
            this.$store.commit('setDate', finalDate.format('DD-MM-YYYY'));
        }

        let time = moment(this.$store.state.time, 'HH:mm');

        fpickr("#fpick", {
          altInput: true,
          dateFormat: 'd-m-Y',
          defaultDate: finalDate.format('DD-MM-YYYY'),
          minDate: defaultDate.format('DD-MM-YYYY'),

        });

        fpickr("#fpick_time", {
          dateFormat: 'H:i',
          enableTime: true,
          defaultHour: time.format('HH'),
          defaultMinute: time.format('mm'),
          minuteIncrement: 30,
          time_24hr: true,
          noCalendar: true
        });
      },
      changeCurrentTab(value) {
        this.$store.commit('setCurrentTab', value);
        if(value == 'package'){
          if(this.$store.state.isOpera){
            // Change back to getOperaPackage after demo
            this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
          } else {
            this.$store.dispatch('getPackage', this.$store.state.venueInfo.id);
          }         
        } else {
          //this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
          if(this.$store.state.isOpera){
            this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
          } else {
            this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
          }
        }
        if(document.documentElement.clientWidth > 1023){
          this.$scrollTo('#showingRoomPackage');
        }
      },
      isRightPackage(packageLength){
        if(!packageLength){
          return true;
        }
        let mt_length = parseInt(this.$store.state.meeting_length);
        let isOpera = this.$store.state.isOpera;
        let pk = '';
        if(mt_length >= 2 && mt_length <= 5){
            pk = '4'
        } else if(mt_length >= 6 && mt_length <= 10 ) {
            pk = '8'
        } else if(this.$store.state.meeting_length == 'overnight'){
            pk = '24'
        } else if(this.$store.state.meeting_length == 'twodays'){
            pk = '36'
        }

        if(packageLength == pk || isOpera){
            return true;
        } else {
            return false;
        }
      },
      toggleDetails() {
        this.$store.commit('toggleDetailId', this.s_room);
        if(document.documentElement.clientWidth > 1023){
          this.$scrollTo('.room_' + this.s_room);
        }
        if(this.details == true) {
          this.detailsRoomText = this.$store.state.strings.details;
          this.details = false;
        } else {
          this.detailsRoomText = this.$store.state.strings.hidedetails;
          this.details = true;
        }
      },
      togglePackageDetails() {
        this.$store.commit('togglePackageDetailId', this.s_package);
        if(document.documentElement.clientWidth > 1023){
          this.$scrollTo('#showingRoomPackage');
        }
        // For package dropdown
        if(this.detailsPackage == true) {
          this.detailsPackageText = this.$store.state.strings.details;
          this.detailsPackage = false;
        } else {
          this.detailsPackageText = this.$store.state.strings.hidedetails;
          this.detailsPackage = true;
        }
      },
      onCollideHandler (collider) {
      },
      nonCollideHandler (collider) {
        this.stickyObject =  {
          position: 'fixed',
          width: '336.66px',
          top: '121px',
          transition: 'all .3 ease-in'
        }
      },
      onGroupOneCollide (collider) {
        this.stickyObject =  {
          position: 'initial',
          width: '336.66px',
          top: '0',
          transition: 'all .3 ease-in'
        }
      },
      nonGroupOneCollide (collider) {
      },
      create(){
        const oldCheckOutHosts = ['sjp.cwteasymeetings.com', 'lilly.cwteasymeetings.com', 'interikea.cwteasymeetings.com', 'meetings.leonardohotels.co.uk', 'devere.meetingpackage.com'];
        if (
            oldCheckOutHosts.some(host => host === window.location.host)
        ) {
            this.createBooking()
        } else {
            this.createNewBooking()
        }
      },
      async createNewBooking() {
        this.$store.commit('setProcessing', 'yes');
        let selectedLang = this.$store.state.selectedLang;
        let startD = this.$store.state.datetime;
        let endD = moment(startD, 'DD-MM-YYYY HH:mm');
        let mt_length = '';
        if(this.$store.state.meeting_length == 'overnight'){
          mt_length = 24;
        } else if(this.$store.state.meeting_length == 'twodays'){
          mt_length = 36;
        } else {
          mt_length = parseInt(this.$store.state.meeting_length);
        } 
        endD = endD.add(mt_length, 'hours');
        endD = endD.format('DD-MM-YYYY HH:mm');
        let currentTab = this.$store.state.currentTab;
        let baseUrl = this.$store.state.baseUrl;

        let ajaxUrl = baseUrl + '/apiv2/create/cart2';
        let sentData = {};
        sentData.language = selectedLang;
        sentData.user_agent = window.navigator.userAgent;
        sentData.venue_id = this.$store.state.venueInfo.id;
        sentData.venue_name = this.$store.state.venueInfo.title;
        sentData.venue_pictures = this.$store.state.venueInfo.venue_pictures;
        sentData.discount_code = this.$store.state.discount_code;
        sentData.venue_type_en = this.$store.state.venueInfo.venue_type_en;
        sentData.country_code = this.$store.state.venueInfo.country_code;
        sentData.city = this.$store.state.venueInfo.city;
        sentData.delegates = this.$store.state.delegates;
        sentData.order_type = currentTab;
        sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
        sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
        sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
        sentData.events = [
          {
            'start' : startD,
            'end' : endD,
            'currency' : this.$store.state.venueInfo.currency_code,
            'room' : {}
          }
        ];
        let availability_id = '';
        if(currentTab == 'room'){
          let roomID = this.$store.state.selectedRoom
          this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
          let selectedRoomInfo = this.$store.state.roomInfo.find(
            obj => obj.id == roomID
          )
          availability_id = selectedRoomInfo.availability_id;
          let flag = this.$store.state.totalPriceIndicator;
          let roomPrice = this.$store.state.price;
          let totalPrice = '';
          if(flag == 'usual'){
              if(mt_length == 24 || mt_length == 36){
                  totalPrice = 0;
              } else {
                  totalPrice = roomPrice;
              }
          } else {
              totalPrice = roomPrice;
          }
          if(selectedRoomInfo.adjusted_meeting_length){
              mt_length = selectedRoomInfo.adjusted_meeting_length;
              endD = moment(startD, 'DD-MM-YYYY HH:mm');
              endD = endD.add(mt_length, 'hours');
              endD = endD.format('DD-MM-YYYY HH:mm');
              sentData.events[0]['endD'] = endD;
          }

          sentData.events[0].room.id = roomID;
          sentData.events[0].room.name = selectedRoomInfo.title;
          sentData.events[0].room.layout_code = this.$store.state.selectedLayout;
          sentData.events[0].package = {};
          sentData.events[0].room.total_price = totalPrice * 100;
          sentData.events[0].room.price_type = selectedRoomInfo.calculated_prices.type;

          sentData.events[0].room.type = selectedRoomInfo.correct_price.type;
          sentData.events[0].room.isInstantBookable = this.isInstantBookable;

        } else {
          let selectedPackageInfo = this.$store.state.packageInfo.find(
            obj => obj.id == this.$store.state.selectedPackage
          )
          let selectedRoominPackageInfo = this.$store.state.rooms_in_package.find(
            obj => obj.id == this.$store.state.selectedRoominPackage
          )
          availability_id = selectedRoominPackageInfo.availability_id;
          if(selectedRoominPackageInfo.adjusted_meeting_length){
              mt_length = selectedRoominPackageInfo.adjusted_meeting_length;
              endD = moment(startD, 'DD-MM-YYYY HH:mm');
              endD = endD.add(mt_length, 'hours');
              endD = endD.format('DD-MM-YYYY HH:mm');
              sentData.events[0]['endD'] = endD;
          }
          let correctDelegates =
            parseInt(this.$store.state.delegates) < parseInt(selectedPackageInfo.package_min)
            ? parseInt(selectedPackageInfo.package_min)
            : parseInt(this.$store.state.delegates)
          sentData.events = [
            {
              'start' : startD,
              'end' : endD,
              'currency' : this.$store.state.venueInfo.currency_code,
              'room' : {
                'id' : this.$store.state.selectedRoominPackage,
                'name' : selectedRoominPackageInfo.title,
                'layout_code' : this.$store.state.selectedLayoutinPackage,
                'isInstantBookable' : this.isInstantBookable
              },
              'package' : {
                'id' : selectedPackageInfo.id,
                'name' : selectedPackageInfo.title,
                'package_min': parseInt(selectedPackageInfo.package_min),
                'total_price': selectedPackageInfo.calculated_prices.price_vat * correctDelegates,
                'unit_price': selectedPackageInfo.calculated_prices.price_vat,
                'price_type': selectedPackageInfo.calculated_prices.type,
                'includes': selectedPackageInfo.services,
              }
            }
          ];
        }

        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }
        sentData.availability_id = availability_id;
        Vue.http.post(ajaxUrl, sentData).then(response => {
          let data = response.body;
          let url = baseUrl + lang + '/book-universal/' + data;
          window.location.href = url;
          }, response => {
        });

      },
      async createBooking() {
        let isOpera = this.$store.state.isOpera;
        let startD = this.$store.state.datetime;
        let endD = moment(startD, 'DD-MM-YYYY HH:mm');
        let mt_length = '';
        let currentTab = this.$store.state.currentTab;
        let isEnquiry = this.$store.state.showEnquiryForm;
        let baseUrl = this.$store.state.baseUrl;
        let selectedProduct;
        if(currentTab == 'room'){
            let roomList = this.$store.state.roomInfo;
            roomList.forEach(element => {
            if(element.id == this.$store.state.selectedRoom){
                selectedProduct = element; 
                selectedProduct.title = element.title;
                selectedProduct.id = this.$store.state.selectedRoom; 
                selectedProduct.category = 'room';
            }
          });
        }else{
            let packageList = this.$store.state.packageInfo;
            packageList.forEach(element => {
              if(element.id == this.$store.state.selectedPackage){
                selectedProduct = element; 
                selectedProduct.title = element.title;
                selectedProduct.id = this.$store.state.selectedPackage; 
                selectedProduct.category = 'package';
              }
            });
        }
        let id_prefix = currentTab == 'room' ? 'r': 'n';
        let name_prefix = currentTab == 'room' ? 'room - ': 'package - ';
        if(this.$store.state.meeting_length == 'overnight'){
          mt_length = 24;
        } else if(this.$store.state.meeting_length == 'twodays'){
          mt_length = 36;
        } else {
          mt_length = parseInt(this.$store.state.meeting_length);
        }
        // Check if this is Opera Venue.
        let operaStartD = moment(startD, 'DD-MM-YYYY HH:mm');
        operaStartD = operaStartD.format('YYYY-MM-DDTHH:mm:ss');
        endD = endD.add(mt_length, 'hours');
        let operaEndD = endD;
        endD = endD.format('DD-MM-YYYY HH:mm');
        operaEndD = operaEndD.format('YYYY-MM-DDTHH:mm:ss');

        if(isOpera){

          this.$store.commit('setProcessing', 'yes');

          let roomIF = [];
          let packageIF = [];
          let layout = '';
          if(currentTab == 'room'){
            let roomList = this.$store.state.roomInfo;
            roomList.forEach(element => {
              if(element.id == this.$store.state.selectedRoom){
                roomIF['name'] = element.title;
                roomIF['photo'] = element.room_pictures[0];
                roomIF['code'] = element.code;
                roomIF['rate_code'] = element.rate_code;
              }
            });
            layout = hf.getLayoutName(this.$store.state.selectedLayout);
            packageIF['name'] = '';
            packageIF['code'] = '';
            packageIF['package_rate_code'] = '';
          } else {

            // Set package min.
            this.$store.commit('setPackageMin', this.minimumCharge);
            let roomList = this.$store.state.rooms_in_package;
            roomList.forEach(element => {
              if(element.id == this.$store.state.selectedRoominPackage){
                roomIF['name'] = element.title;
                roomIF['photo'] = element.room_pictures[0];
                roomIF['code'] = element.code;
                roomIF['rate_code'] = '';
              }
              layout = hf.getLayoutName(this.$store.state.selectedLayoutinPackage);
            });

            let packageList = this.$store.state.packageInfo;
            packageList.forEach(element => {
              if(element.id == this.$store.state.selectedPackage){
                packageIF['name'] = element.title;
                packageIF['code'] = element.id;
                packageIF['package_rate_code'] = element.package_rate_code;
              }
            });
          }
          

          this.$store.commit('setCheckOutItems', {
            'startD' : startD,
            'endD' : endD,
            'operaStartD' : operaStartD,
            'operaEndD' : operaEndD,
            'currency': this.$store.state.venueInfo.currency_code,
            'currencySymbol' : this.$store.state.venueInfo.currency,
            'room' : roomIF['name'],
            'room_code' : roomIF['code'],
            'delegates' : this.$store.state.delegates,
            'layout' : layout,
            'venue' : this.$store.state.venueInfo.title,
            'room_rate_code' : roomIF['rate_code'],
            'roomPhoto' : roomIF['photo'],
            'roomPrice' : this.$store.state.roomPrice,
            'roomTotalPrice' : this.$store.state.roomTotalPrice,
            'package' : packageIF['name'],
            'package_code' : packageIF['code'],
            'package_rate_code' : packageIF['package_rate_code'],
            'isInstantBookable': this.isInstantBookable
          });

          // Get Opera Menu Items.
          this.$store.dispatch('getOperaMenuItems').then((data) => {
            // #loghere
            let operaMenuItemsList = data.body.MeetingFetchMenuItemResponse.MenuItems;
            // Purify list
            let newList = [];
            operaMenuItemsList.forEach(element => {
              let elementPrice = 0;
              if(element.Charges.RevenueTypes.BaseRate.Amount){
                elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate.Amount);
              } else {
                elementPrice = parseFloat(element.Charges.RevenueTypes.BaseRate[0].Amount);
              }
              let newItem = {
                'id' : element.MenuItemID,
                'name' : element['@attributes'].name1,
                'price' : elementPrice,
                'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              };
              if(elementPrice > 0){
                newList.push(newItem);
              }         
            });

            this.$store.commit('setOperaMenuItems', newList);
            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }
          });


          // Get Opera Misc Items.
          this.$store.dispatch('getOperaMiscItems').then((data) => {
            // #loghere

            let operaMiscItemsList = data.body.MeetingFetchMiscellaneousItemResponse.MiscellaneousItems;
            // Purify list
            let newList = [];
            operaMiscItemsList.forEach(element => {
              let newItem = {
                'id' : element.ItemID,
                'name' : element.Description.Text,
                'amount' : 1,
                'price' : parseFloat(element.RateCodes.Rate.RevenueTypes.BaseRate.Amount),
                'priceWithCC' : parseFloat(element.RateCodes.Rate.RevenueTypes.BaseRate.Amount) == 0 ? 'Free' : element.RateCodes.Rate.RevenueTypes.BaseRate.Amount + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              };
              newList.push(newItem);
            });

            this.$store.commit('setOperaMiscItems', newList);
            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }
          });

          // Get Opera Menus.
          this.$store.dispatch('getOperaMenus').then((data) => {
            // #loghere
            let operaMenusList = data.body.MeetingFetchMenuResponse.Menus;
            // Purify list
            let newList = [];

            let _operaMenusList = [];

            if(operaMenusList.MenuID){ // Only 1 menu
              _operaMenusList.push(operaMenusList);
            } else {
              _operaMenusList = operaMenusList;
            }


            _operaMenusList.forEach(element => {
              let price = 0;
              let componentPrice = 0;
              let menuItemsList = [];
              // Package price 
              let revenueTypes = element.Charges.RevenueTypes;
              if(revenueTypes){
                if(revenueTypes.BaseRate){
                  let elementPrice = 0;
                  if(revenueTypes.BaseRate.Amount){
                    elementPrice = parseFloat(revenueTypes.BaseRate.Amount);
                  } else {
                    elementPrice = parseFloat(revenueTypes.BaseRate[0].Amount);
                  }
                  price += parseFloat(elementPrice);
                } else {
                  revenueTypes.forEach(el => {
                    let elementPrice = 0;
                    if(el.BaseRate.Amount){
                      elementPrice = parseFloat(el.BaseRate.Amount);
                    } else {
                      elementPrice = parseFloat(el.BaseRate[0].Amount);
                    }
                    price += parseFloat(elementPrice);
                  });
                }
              }

              menuItemsList.push({
                'id' : element.MenuID,
                'name' : 'Menu',
                'amount' : this.$store.state.delegates,
                'price' : price,
                'priceWithCC' : price + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--'
              });

              // Component price
              let menuItems = element.MenuItems;
              if(menuItems){
                if(menuItems.MenuItemID){ // only 1 menu item.
                  if(menuItems.Charges){
                    let elementPrice = 0;
                    if(menuItems.Charges.RevenueTypes.BaseRate.Amount){
                      elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate.Amount);
                    } else {
                      elementPrice = parseFloat(menuItems.Charges.RevenueTypes.BaseRate[0].Amount);
                    }
                    componentPrice += elementPrice;
                    menuItemsList.push({
                      'id' : menuItems.MenuItemID,
                      'name' : menuItems['@attributes'].name1,
                      'amount' : this.$store.state.delegates,
                      'price' : elementPrice,
                      'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                      'service_time' : '--:--'
                    });
                  }
                } else {
                  menuItems.forEach(el => {
                    let elementPrice = 0;
                    if(el.Charges){
                      if(el.Charges.RevenueTypes.BaseRate.Amount){
                        elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate.Amount);
                      } else {
                        elementPrice = parseFloat(el.Charges.RevenueTypes.BaseRate[0].Amount);
                      }
                      componentPrice += elementPrice;
                      menuItemsList.push({
                        'id' : el.MenuItemID,
                        'name' : el['@attributes'].name1,
                        'amount' : this.$store.state.delegates,
                        'price' : elementPrice,
                        'priceWithCC' : elementPrice + ' ' + this.$store.state.venueInfo.currency,
                        'service_time' : '--:--'
                      });
                    }
                  });
                }
              }

              let finalPrice = price + componentPrice;

              let newItem = {
                'id' : element.MenuID,
                'name' : element['@attributes'].name,
                'amount' : this.$store.state.delegates,
                'price' : finalPrice,
                'priceWithCC' : finalPrice + ' ' + this.$store.state.venueInfo.currency,
                'service_time' : '--:--',
                'menuItems' : menuItemsList
              };
              if(finalPrice > 0){
                newList.push(newItem);
              }
              
            });

            this.$store.commit('setOperaMenus', newList);

            // End Purify list
            this.$store.commit('setAddonAjaxCounter');

            if(this.$store.state.addOnCounter == 3){
              this.$store.commit('showCheckOutPage', 'yes');
              this.$store.commit('setProcessing', 'no');
              this.$scrollTo('.top-bar');
            }

          });

          return;
        }


        // If booking.com here we set some cookies for the thank you page.
        let site_url = window.location.host;
        if(site_url == 'booking.meetingpackage.com' || site_url == 'meetingpackage.com' ){
          let check_in_date = moment(this.$store.state.date, 'DD-MM-YYYY').format('YYYY-MM-DD');
          let check_out_date = moment(check_in_date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD');
          let latlon = this.$store.state.venueInfo.latlon.split(',');
          let latitude = latlon[0];
          let longitude = latlon[1];
          this.$cookie.set('bk_check_in_date', check_in_date);
          this.$cookie.set('bk_check_out_date', check_out_date);
          this.$cookie.set('bk_latitude', latitude);
          this.$cookie.set('bk_longitude', longitude);
        }

        this.$store.commit('setProcessing', 'yes');
        let lang = this.$store.state.selectedLang;
        if(lang == 'en'){
          lang = '';
        } else {
          lang = '/' + lang;
        }
        
        let ajaxUrl = '';
        ajaxUrl = baseUrl + '/apiv2/create/cart';

        let sentData = {};
        sentData.accepted_gdpr = this._accepted_gdpr;
        sentData.start = startD;
        sentData.end = endD;
        sentData.order_type = currentTab;
        sentData.marketing_platform_ids = dataLayer.getMarketingPlatformIds();
        sentData.mp_ga_session_data = await dataLayer.getGASessionInfo(window.mp_measurement_id);
        sentData.wl_ga_session_data = await dataLayer.getGASessionInfo(window.wl_measurement_id);
        sentData.delegates = this.$store.state.delegates;
        sentData.isInstantBookable = this.isInstantBookable;
        sentData.user_agent = window.navigator.userAgent;
        if(this.$store.state.serviceFeeWithEnquiry && isEnquiry){
          sentData.service_fee = this.$store.state.venueInfo.service_fee.id;
        }

        // User Info
        if(this.$store.state.userInfo == false){
          sentData.company = this.s_company;
          sentData.firstName = this.s_name;
          sentData.lastName = this.s_lname;
          sentData.phone = this.s_phone;
          sentData.email = this.s_email;
          sentData.phone_country = this.$store.state.countryPhoneCode;
          sentData.additional_info = this.s_additional_info;
        } else {
          sentData.company = this.$store.state.userInfo.company;
          sentData.firstName = this.$store.state.userInfo.first_name;
          sentData.lastName = this.$store.state.userInfo.last_name;
          if(this.userPhone == ''){
            sentData.phone = this.s_phone_logged_in;
          } else {
            sentData.phone = this.$store.state.userInfo.phone;
          }
          sentData.email = this.$store.state.userInfo.email;
          sentData.additional_info = this.s_additional_info;
        }

        sentData.venue_id = this.$store.state.venueInfo.id;
        sentData.language = lang;
        sentData.currency = this.$store.state.venueInfo.currency_code;

        if(currentTab == 'room'){
          this.$cookie.set('room_booking_type', this.$store.state.roomBookingType);
          sentData.room = this.$store.state.selectedRoom;
          sentData.layout = this.$store.state.selectedLayout;
          sentData.package_id = 'none';
          sentData.room_price = this.roomPrice;
          sentData.room_price_total = this.roomTotalPrice;

        } else {
          // Package booking.
          sentData.room = this.$store.state.selectedRoominPackage;
          sentData.layout = this.$store.state.selectedLayoutinPackage;
          sentData.package_id = this.$store.state.selectedPackage;
          sentData.package_price = this.packagePrice;
          sentData.package_price_total = this.packageTotalPrice;
        }
      let product = {...sentData, ...selectedProduct };
      product.mt_length = mt_length;
      this.storeProduct(product,  this.$store.state.venueInfo);
        Vue.http.post(ajaxUrl, sentData).then(response => {
          let data = response.body;
          let url = '';
          if(!isEnquiry){
            url = baseUrl + lang + '/checkout/' + data; 
          } else {
            if(this.$store.state.userInfo == false){
              url = baseUrl + lang + '/thank-you-anon';
            } else {
              url = baseUrl + lang + '/checkout/' + data;
            }
          }

          if(isEnquiry && window.location.host != 'sjp.cwteasymeetings.com' && window.location.host != 'lilly.cwteasymeetings.com' && window.location.host != 'interikea.cwteasymeetings.com'){
            Vue.http.post(baseUrl + '/apiv2/process/' + data, sentData).then(response => {
              window.location.href = url;
            });

          } else {
            if(window.location.host == 'sjp.cwteasymeetings.com' || window.location.host == 'lilly.cwteasymeetings.com' || window.location.host == 'interikea.cwteasymeetings.com'){
              this.$store.dispatch('goToCheckout', {...sentData, orderId: data});
            } else {
              window.location.href = url;
            }
          }
        }, response => {
            if(response.data && response.data.field && response.data.message){
                this.errorMessages[response.data.field] = response.data.message;
            }
            this.$store.commit('setProcessing', 'no');
        });
      },
      validateBeforeSubmit() {
        let self= this;
        let countryCode = this.$store.state.countryPhoneCode;
        if(!this.$store.state.userInfo){
          this.$validator.validateAll().then((result) => {
            self.$refs.phoneChild.$validator.validateAll().then((childResult) => {
              if(result && childResult) {
                if(countryCode){
                  this.create();
                } else {
                  this.noCC = true;
                }
              }
            });
          });
        } else {
          if(this.userPhone == ''){
            this.$refs.phoneChild_LoggedIn.$validator.validateAll().then((childResult) => {
              if(childResult) {
                if(countryCode){
                  this.create();
                } else {
                  this.noCC = true;
                }
              }
            });
          } else {
            this.create();
          }
        }
      },
      checkAndChangeStartTime() {
        var selectedDate = moment(this.s_date, 'DD-MM-YYYY')
        var today = moment().startOf('day')
        if (selectedDate.diff(today, 'days') === 0) {
          this.s_time = {HH: (moment().hour() + 1).toString(), mm: "00"}
        }
      }
    },
    watch: {
        countryCode: function (value) {
          if(value == '') {
            this.noCC = true;
          } else {
            this.noCC = false;
          }
        },
        lang: function(value) {
          this.reRender(value)
        },
        '$store.state.isOpera': function(newValue, oldValue) {
            this.reRender(this.$store.state.selectedLang);
            if(newValue == true && this.$store.state.currentTab == 'package'){
                this.changeCurrentTab('package');
            }
        },
        totalPrice : function(value) {
        },
        detailsText() {
          if (this.$store.state.detailsText == true) {
            this.detailsRoomText = this.$store.state.strings.details;
            this.details = false;
          } else {
            this.detailsRoomText = this.$store.state.strings.hidedetails;
            this.details = true;
          }
        },
        detailsTextPackage() {
          if (this.$store.state.detailsTextPackage == true) {
            this.detailsPackageText = this.$store.state.strings.details;
            this.detailsPackage = false;
          } else {
            this.detailsPackageText = this.$store.state.strings.hidedetails;
            this.detailsPackage = true;
          }
        },
        s_date() {
          this.checkAndChangeStartTime()
        }
    },
    mounted() {
      fpickr.localize(english);
      fpickr("#fpick", {
          altInput: true,
          dateFormat: "d-m-Y",

          //defaultDate: this.$store.state.datetime,
          //minDate: new Date().fp_incr(2)
      });
      fpickr("#fpick_time", {
          dateFormat: "H:i",
          enableTime: true,
          //defaultDate: this.$store.state.datetime,
          //minDate: new Date().fp_incr(2)
      });

      // check what browser
      if (browser) {
        if(browser.name == 'ie' && parseFloat(browser.version) > 10 ) {
          this.isIE = true;
        }
      }
      this.checkAndChangeStartTime()
    },
    computed: {
      isDavinci() {
        return window.isDavinci
      },
      showEstimatedLocalPrice() {
        if (this.isDavinci && this.$store.state.venueInfo.local_currency_code && (this.$store.state.venueInfo.currency_code !== this.$store.state.venueInfo.local_currency_code)) {
            return true
        }
        return false
      },
      isUSCase(){
        if(
          (window.location.hostname == 'cts.meetingpackage.com' || 
          window.location.hostname == 'local.test'  ||
          window.location.hostname == 'lockton.meetingpackage.com') &&
          this.$store.state.venueInfo.country_code == 'US'
          ){
          return true;
        } else {
          return false;
        }
      },
      isCWTDomain() {
        return window.location.hostname.includes('cwteasymeetings')
      },
      businessHours() {
        return this.$store.state.businessHours;
      },
      isSJP() {
        return this.$store.state.isSJP;
      },
      userPhone() {
        return this.$store.state.userPhone;
      },
      countryCode() {
        return this.$store.state.countryPhoneCode;
      },
      isPackageTabRemoved() {
        return this.$store.state.isPackageTabRemoved;
      },
      isLoading() {
        return this.$store.state.isLoading;
      },
      strings () {
	      return this.$store.state.strings
      },
      isDisabled() {
        if(this.$store.state.currentTab == 'room'){
          return this.$store.state.isRoomFormDisabled;
        } else {
          return this.$store.state.isPackageFormDisabled;
        }
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
      venueInfo(value) {
        this.vInfo = this.$store.state.venueInfo;
        return this.$store.state.venueInfo;
      },
      packageCurrent() {
        if(this.$store.state.currentTab != 'package'){
          return false;
        } else {
          return true;
        }
      },
      roomCurrent() {
        if(this.$store.state.currentTab == 'package'){
          return false;
        } else {
          return true;
        }
      },
      packageInfo() {
        return this.$store.state.packageInfo;
      },
      roomInfo() {
        return this.$store.state.roomInfo;
      },
      selectedPrice(){
        return this.$store.state.selectedPrice;
      },
      selectedPrice_decimal(){
        return this.$store.state.selectedPrice_decimal;
      },
      p_selectedPrice(){
        return this.$store.state.p_selectedPrice;
      },
      p_selectedPrice_decimal(){
        return this.$store.state.p_selectedPrice_decimal;
      },
      currencySymbol(){
        return this.$store.state.currencySymbol;
      },
      currencyCode() {
        return this.$store.state.venueInfo.currency_code;
      },
      localCurrencyCode (){
        return this.$store.state.venueInfo.local_currency_code;
      },
      footerCollided () {
        return this.$store.state.footerCollided
      },
      showEnquiry () {
        this.$cookie.delete('instant_booking');
        return this.$store.state.showEnquiryForm;
      },
      showServiceFee () {
        return this.$store.state.venueInfo.service_fee && this.$store.state.venueInfo.service_fee.amount && this.$store.state.isRegus == false && this.$store.state.isOpera == false;
      },
      accepted_gdpr: {
        get: function () {
          this._accepted_gdpr = this.$store.state.userInfo.is_accepted_gdpr;
          return this.$store.state.userInfo.is_accepted_gdpr;
        },
        set: function (value) {
          this._accepted_gdpr = value;
        }
      },
      s_package: {
        get: function(){
          return this.$store.state.selectedPackage
        },
        set: function(selectedPackage){
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#packageList');
          }
          // Mutate selected package.
          this.$store.commit('setSelectedPackage', selectedPackage);
          this.$store.state.packageInfo.forEach(element => {
                if(element.id == selectedPackage) {
                    this.$store.dispatch('sortRoomListinPackage', element.rooms)
                }
            });
          this.$store.commit('changeSelectedPricePackage', selectedPackage);
        }
      },
      s_room: {
        get: function () {
          if(this.$store.state.currentTab == 'room'){
            return this.$store.state.selectedRoom
          } else {
            return this.$store.state.selectedRoominPackage
          }

        },
        set: function (selectedRoom) {
          if(this.$store.state.currentTab == 'room'){
            if(document.documentElement.clientWidth > 1023){
              let count = 0;
              this.$store.state.roomInfo.forEach(el => {
                if(el.id == selectedRoom){
                  this.$store.commit('setSelectedRoomIndex', count);
                }
                count++;
              })
            }
            //this.$scrollTo('.room_' + selectedRoom);
            this.$store.commit('setSelectedRoom', selectedRoom);
            this.$store.commit('setLayoutsInRoom', selectedRoom);
            this.$store.commit('changeSelectedPrice', selectedRoom);
          } else {
            if(document.documentElement.clientWidth > 1023){
              let count = 0;
              this.$store.state.rooms_in_package.forEach(el => {
                if(el.id == selectedRoom){
                  this.$store.commit('setSelectedRoomIndex', count);
                }
                count++;
              })
            }

            this.$store.commit('setSelectedRoominPackage', selectedRoom);
            this.$store.commit('setLayoutsInRoom', selectedRoom);
          }

        }
      },
      s_layout: {
        get: function () {
          if(this.$store.state.currentTab == 'room'){
            return this.$store.state.selectedLayout
          } else {
            return this.$store.state.selectedLayoutinPackage
          }
        },
        set: function (selectedLayout) {
          if(this.$store.state.currentTab == 'room'){
            this.$store.commit('setSelectedLayout', selectedLayout);
          } else {
            this.$store.commit('setSelectedLayoutinPackage', selectedLayout);
          }
        }
      },
      s_meetingLength: {
        get: function () {
          return this.$store.state.meeting_length
        },
        set: function (meetingLength) {
          this.$store.commit('setMeetingLength', meetingLength);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }   
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              this.$store.dispatch('getPackage', this.$store.state.venueInfo.id);
            }
          }
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#showingRoomPackage');
          }
          this.$store.dispatch('checkBizHours');
        }
      },
      s_delegates: {

        get: function () {
          return this.$store.state.delegates || 1;
        },
        set: function (delegates) {
          if(delegates == '' || delegates == 0 || delegates == '0'){
            delegates = 1;
          }
          // #hack for berghansen
          if(delegates > 25 && window.location.hostname == 'berghansen.meetingpackage.com'){
            delegates = 25;
          }
          this.$store.commit('setDelegates', delegates);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else {
              //this.$store.dispatch('sortRoomList');
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }          
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              //this.$store.dispatch('sortPackageList');
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
            
          }
          if(document.documentElement.clientWidth > 1023){
            this.$scrollTo('#showingRoomPackage');
          }
        }
      },
      s_date: {
        get: function () {
          return this.$store.state.date
        },
        set: function (date) {
          this.$store.commit('setDate', date);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }    
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
          }

          this.$store.dispatch('checkBizHours');
        }
      },
      s_time: {
        get: function () {
          let timeArr = this.$store.state.time.split(':');
          //return this.$store.state.time
          return {
            HH: timeArr[0],
            mm: timeArr[1]
          }
        },
        set: function (time) {
          let combinedTime = time.HH + ':' + time.mm;
          this.$store.commit('setTime', combinedTime);
          if(this.$store.state.currentTab == 'room'){
            if(this.$store.state.isOpera){
              this.$store.dispatch('getRoomOpera', {
                'id' : this.$store.state.venueInfo.id,
                'hotelID' : this.$store.state.venueInfo.operaHotelID,
                'hotelChainCode' : this.$store.state.venueInfo.operaChainCode,
                'hotelServer' : this.$store.state.venueInfo.operaServer
              });
            } else {
              this.$store.dispatch('getRoom', this.$store.state.venueInfo.id);
            }
          } else {
            if(this.$store.state.isOpera){
              this.$store.dispatch('getOperaPackage', this.$store.state.venueInfo.id);
            } else {
              this.$store.dispatch('checkAvailabilityandPricesfromPackage', this.$store.state.datetime);
            }
          }

          this.$store.dispatch('checkBizHours');
        }
      },
      isInstantBookable() {


        if(this.$store.state.currentTab == 'room'){
          if(this.$store.state.isInstantBookable && parseFloat(this.totalPrice) > 0){
            this.$cookie.set('instant_booking', true);
          } else {
            this.$cookie.delete('instant_booking');
          }
          return this.$store.state.isInstantBookable;
        } else {
          if(this.$store.state.isInstantBookablePackage && parseFloat(this.totalPrice) > 0){
            this.$cookie.set('instant_booking', true);
          } else {
            this.$cookie.delete('instant_booking');
          }
          return this.$store.state.isInstantBookablePackage;
        }

      },
      perWhat() {
        return this.$store.state.perWhat;
      },
      totalPrice() {
        let totalPrice = '';
        let currentTab = this.$store.state.currentTab;
        let delegates = this.$store.state.delegates;
        let mt_length = this.$store.state.meeting_length;
        let allPackages = this.$store.state.packageInfo;

        let price = '';
        if(currentTab == 'room'){
          let flag = this.$store.state.totalPriceIndicator;
          price = this.$store.state.price;
          if(mt_length == 'overnight' || mt_length == 'twodays'){
            totalPrice = 0;
          } else {
            if(flag == 'usual'){
              totalPrice = price * parseInt(mt_length);
            } else {
              totalPrice = price;
            }

          }
        } else {
          // If current tab is package.
          price = this.$store.state.p_price
          if(allPackages){
            allPackages.forEach(element => {
            if(element.id == this.$store.state.selectedPackage){
              if(parseInt(element.package_min) > parseInt(delegates)){
                delegates = element.package_min
              }
            }
          });
          }
          totalPrice = Math.round(price * delegates)
          this.packagePrice = price;
          this.packageTotalPrice = totalPrice;
        }
        if(price != ''){
          if(totalPrice == 0){
            this.$store.commit('setShowEnquiryForm', 'yes');
          } else {
            this.$store.commit('setShowEnquiryForm', 'no');
          }
          this.roomPrice = price;
          this.$store.commit('setRoomPrice', price);
          this.roomTotalPrice = totalPrice;
          this.$store.commit('setRoomTotalPrice', totalPrice);
        } else {
          this.$store.commit('setShowEnquiryForm', 'no');
        }
        return parseFloat(totalPrice).toFixed(2);
      },
      localTotalPrice() {
        let orignalTotalPrice = parseFloat(this.totalPrice) ? parseFloat(this.totalPrice) : 0
        let result = (orignalTotalPrice * this.$store.state.venueInfo.local_currency_conversion_rate).toFixed(2)
        return result
      },
      currentTab() {
        return this.$store.state.currentTab;
      },
      minimumCharge() {
        let allPackages = this.$store.state.packageInfo;
        let minCharge = '';
        if(allPackages){
          allPackages.forEach(element => {
            if(element.id == this.$store.state.selectedPackage){
              minCharge = element.package_min;
            }
          });
        }
        return minCharge;
      },
      delegates() {
        return parseInt(this.$store.state.delegates);
      },
      detailsText() {
        return this.$store.state.detailsText;
      },
      detailsTextPackage() {
        return this.$store.state.detailsTextPackage;
      },
      phoneNumber(){

        if(window.location.hostname == 'berghansen.meetingpackage.com'){
          return '+47 22 00 80 50';
        }

        if(window.location.hostname == 'sjp.cwteasymeetings.com'){
          return '+44(0) 20 3353 0274';
        }

        let selectedLang = this.$store.state.selectedLang;
        let phoneNumberList = this.$store.state.phoneNumberList;
        if (phoneNumberList[selectedLang]){
          return phoneNumberList[selectedLang];
        } else {
          return phoneNumberList['en'];
        }
      },
      isOutsideBusinessHours(){
        return this.$store.state.isOutsideBusinessHours;
      },
      getTimePickerHourRange() {
        var selectedDate = moment(this.s_date, 'DD-MM-YYYY')
        var today = moment().startOf('day')
        if (selectedDate.diff(today, 'days') === 0)
          return [[moment().hour() + 1, 23]]
        else 
          return [[0, 23]]
      }
    }
  }
</script>
<style scope>
  .small_text {
    font-weight: 400;
    font-size: 70%;
  }
  .big_flex {
    flex: 2 !important;
  }
  .v-spinner {
    margin-left: 0;
  }

</style>
